import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure42 = {
  chart: {
    zoomType: 'xy',
    animation: false,
    marginTop: 50,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'bar',
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
    style: {
      fontFamily: 'Montserrat'
    }
  },

  colors: ['#5b9bd5'],

  credits: {
    enabled: false
  },
  title: {
    text: null
  },
  subtitle: {
    text: null
  },

  plotOptions: {
    series: {
      borderWidth: 0,
      marker: {
        symbol: 'circle',
        enabled: false,
        states: {
          hover: {
            enabled: true,
            radius: 5
          }
        }
      }
    }
  },

  exporting: {
    enabled: false
  },


  xAxis: [{
    categories: [
		 "Monde",
		 "Pays en développement sans littoral (PDSL)",
		 "Petits États insulaires en développement (PEID)",
		 "Pays les moins avancés (PMA)",
		 "Asie de l’Est et Asie du Sud-Est",
		 "Océanie",
		 "Amérique latine et Caraïbes",
		 "Afrique subsaharienne",
		 "Asie de l’Ouest et Afrique du Nord",
		 "Amérique du Nord et Europe ",
		 "Asie centrale et Asie du Sud",
    ],
    lineColor: "#d7d7d7",
    tickColor: "#d7d7d7",
    tickLength: 16,
    labels: {

      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      }
    },
  }],
  yAxis: [{ // Primary yAxis
    labels: {
     
      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    gridLineWidth: 0,
    max: 14,
    min: -2,
    tickInterval: 2,
    title: {
      text: null,
      style: {
        color: Highcharts.getOptions().colors[1]
      }
    }
  }],
  tooltip: {
    shared: true,
    useHTML: true,
    hideDelay: 500,
    backgroundColor: null,
    borderWidth: 0,
    shadow: false,
    style: {
      padding: 0
    }
  },
  legend: {
    enabled: false,
  },

  series: [{
    name: '',
    tooltip: {
      valueSuffix: '%'
    },
    dataLabels: {
      enabled: true,
      style: {
        fontWeight: 'normal',
        textOutline: false,
        color: '#999999',
        fontSize: '12px'
      }

    },
    data: [
        {y: 0.3, color: '#ff101a'},
        {y: 0.6, color: '#ff101a'},
        {y: 0.1, color: '#ff101a'},
        {y: 0.0, color: '#ff101a'},
        {y: 0.1, color: '#ff101a'},
        {y: 0.1, color: '#ff101a'},
        {y: 0.3, color: '#ff101a'},
        {y: 0.2, color: '#ff101a'},
        {y: 12.7, color: '#ff101a'},
        {y: 0.2, color: '#ff101a'},
        {y: -0.9, color: '#5b9bd5'}
    ]
  }]

}